import React, { useState } from "react"
import { Box, IconButton } from "@mui/material"

import medical from '../assets/icons/medicaldata.svg'
import calendar from '../assets/icons/calendar.svg'
import call from '../assets/icons/consult.svg'

import medicalG from '../assets/icons/medicaldataG.svg'
import calendarG from '../assets/icons/calendarG.svg'
import callG from '../assets/icons/consultG.svg'
import logoutIcon from '../assets/icons/logoutIcon.svg'

import kiosk from '../assets/icons/kiosk.svg'
import kioskG from '../assets/icons/kioskG.svg'

import { useNavigate } from "react-router-dom"
import styles from './Login.module.css'
import ModalAlert from '../components/modal/ModalAlert'
import { useDispatch, useSelector } from "react-redux"

import {logout} from '../store/authSlice'
import * as apiAuth from '../services/ApiAuthentication'

import { MdBloodtype } from "react-icons/md";
import { BsSmartwatch } from "react-icons/bs";
import { SiSmartthings } from "react-icons/si";


export default function MainMenu() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [openModal, setOpenModal] = useState(false)
    const userData = useSelector((state) => state.auth.user_data)

    const menu = [
        {
            key: 'history',
            value: 'ตรวจสอบประวัติ',
            image: medical,
            imageG: medicalG,
            status: true
        },
        //{
        //    key: 'annual',
        //    value: 'ผลตรวจสุขภาพ \n ประจำปี',
        //    image: healthcheck,
        //    imageG: healthcheckG,
        //    status: true
        //},
        //{
        //    key: 'lab',
        //    value: 'ผลตรวจแลป \n นอกสถานที่',
        //    image: lab,
        //    imageG: labG,
        //    status: true
        //},
        {
            key: 'healthATM',
            value: 'ผลจาก Sonka\n HealthATM',
            image: kiosk,
            imageG: kioskG,
            status: true
        },
        {
            key: 'IoTs',
            value: 'ผลจาก IoTs /\nHealth Station',
            icon: SiSmartthings,
            status: true
        },
        {
            key: 'blood',
            value: 'ผลตรวจเลือด\nBlood Tests',
            icon: MdBloodtype,
            status: true
        },
        {
            key: 'smartWatch',
            value: 'ผลการวัดจาก\nSmart Watch',
            icon: BsSmartwatch,
            status: true
        },
        {
            key: 'appointments',
            value: 'รายการนัดหมาย',
            image: calendar,
            imageG: calendarG,
            status: true
        },
        {
            key: 'consult',
            value: 'ปรึกษาออนไลน์\nTelemed',
            image: call,
            imageG: callG,
            status: true
        },
        // {
        //     key: 'refer',
        //     value: 'เอกสารการส่งต่อ',
        //     image: docRefer,
        //     imageG: docReferG,
        //     status: true
        // },
        //{
        //    key: 'xray',
        //    value: 'ดูประวัติ X-RAY',
        //    image: xray,
        //    imageG: xrayG,
        //    status: true
        //},
        {
            key: 'logout',
            value: '',
            image: logoutIcon,
            imageG: logoutIcon,
            status: true,
            class: styles.boxMenuTransparent,
        },
    ]

    const clickMenu = (item) => {

        let cid = userData?.pid ?? "";
        if (item['key'] === 'history') { //ประวัติการรักษา ในโรงพยาบาลเครือข่าย
            navigate(`/medicalInformationNew`)
        //} else if (item['key'] === 'annual') { //ผลตรวจสุขภาพ ประจำปี
        //    navigate('/healthResultsAnnual')
        //} else if (item['key'] === 'lab') { //ผลตรวจแลป นอกสถานที่
        //    navigate(`/offsiteLabResults?PID=${cid}`)
        } else if (item['key'] === 'healthATM') { //คัดกรองสุขภาพ ความดันและน้ำตาล
            navigate(`/healthATM?PID=${cid}`)
        } else if (item['key'] === 'IoTs') { //คัดกรองสุขภาพ ความดันและน้ำตาล
            navigate(`/healthIoTs`)
        } else if (item['key'] === 'blood') { // Blood Test Results
            navigate(`/bloodResults`)
        } else if (item['key'] === 'smartWatch') { // SmartWatch
            navigate(`/smartWatch?PID=${cid}`)
        } else if (item['key'] === 'appointments') { //รายการนัดหมาย
            navigate(`/appointmentList`)
        } else if (item['key'] === 'consult') { //ปรึกษาหมอ
            navigate('/consult')
        //} else if (item['key'] === 'refer') { //เอกสารการส่งต่อ
        //    navigate('/refer')
        //} else if (item['key'] === 'xray') { //ดูประวัติ X-RAY
        //    navigate('/xray')
        } else if (item['key'] === 'logout') { //logout
            apiAuth.logout();
            dispatch(logout())
            localStorage.clear()
            navigate('/')
        }

    }

    return (
        <div className='bg__health__atm'>
            {openModal ?
                <ModalAlert
                    detail={'กรุณาเสียบบัตรประชาชน'}
                    onClose={() => { setOpenModal(false) }}
                />
                : null
            }

            <Box sx={{
                height: '100vh',
                display: 'flex',
                justifySelf: 'center',
                fontSize: '1rem',
                '@media (orientation: portrait)': {
                    fontSize: '3vw',
                }
            }}>
                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr 1fr',
                    justifySelf: 'center',
                    alignSelf: 'center',
                    gridGap: '0.6em',
                    justifyContent: 'space-evenly',
                    '@media (orientation: portrait)': {
                        display: 'flex',
                        flexWrap: 'wrap',
                        rowGap: '1.25em',
                        columnGap: 0,
                        //'@media (min-width: 1000px)': {
                        //    alignSelf: 'end'
                        //}
                    }
                }}>
                    {menu.map((i, idx) => (

                        <Box key={idx}
                            {...(i['status'] ?
                                {
                                    className: i['class'] ? i['class'] : styles.boxMenu,
                                    onClick:() => { clickMenu(i) }
                                }
                                :
                                {
                                    className: i['class'] ? i['class'] : styles.boxMenuDis,
                                }
                            )}
                            sx={{
                                rowGap: 0,
                                '@media (orientation: portrait)': {
                                    width: '40vw',
                                    height: '40vw',
                                    '@media (min-width: 1000px)': {
                                        height: '20vh',
                                    }
                                },
                            }}
                        >
                            <Box sx={{
                                display:"flex",
                                justifyContent:"center",
                                width: '30%',
                                '@media (min-width: 1000px)': {
                                    width: '40%',
                                }
                            }}>
                                { i['icon'] ?
                                    <IconButton
                                        aria-label={i['value']}
                                        color={i['status'] ? "c_yellow" : "secondary"}
                                        sx={{
                                            m: '0.5em',
                                            '@media (min-width: 1000px)': {
                                                fontSize: '4vw',
                                            },
                                            '@media (orientation: landscape)': {
                                                fontSize: '1.25rem',
                                            },
                                        }}
                                    >
                                        {(() => {
                                            const Icon = i['icon'];
                                            return <Icon size='2.5em' />;
                                        })()}
                                    </IconButton>
                                    :
                                    <img
                                        src={i['status'] ? i['image'] : i['imageG']}
                                        alt={i['value']}
                                        style={{
                                            display:'block',
                                            width: '100%',
                                            height: 'auto',
                                            margin: '1em'                                            
                                        }}
                                    />
                                }
                            </Box>
                            <Box sx={{
                                color: i['status'] ? 'primary.contrastText' : 'secondary.main',
                                fontSize: '1.25em',
                                display: 'grid',
                                justifyItems: 'center',
                            }}>
                                {i['value'].split('\n').map((item, index) =>
                                    <div key={index}>{item}</div>
                                )}
                            </Box>
                        </Box>

                    ))}
                </Box>

            </Box>

        </div>
    )
}